<div usbLoadingSplash [appLoading]="appLoading" [fullscreen]="true" [component]="'yourtrip'">
  <usb-trip-header
    *ngIf="actualItinerary"
    [title]="nameItinerary"
    [destinySecuency]="destinySecuency"
    [arrivalDateFull]="userService?.itineraryArrivalDateFull"
    [departureDateFull]="userService?.itineraryDepartureDateFull"
    [timeArrive]="timeArrive"
    [timeDropoff]="timeDropoff"
    [qtyDays]="qtyDays"
    [qtyNights]="qtyNights"
    [adults]="adults"
    [children]="children"
    [hasHotel]="existHotel()"
    [itinerary]="actualItinerary"
    [payloadSearchTransportFly]="payloadSearchTransportFly"
    [formTransportsFly]="formTransportsFly"
    [clientSetting]="getClientsSettingAppBooking"
  >
  </usb-trip-header>
</div>